import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { DependentGender, DependentRelationship } from "./types";

export const DependentRelationshipOptions = [
  {
    label: i18n.t("brother"),
    value: DependentRelationship.Brother,
  },
  {
    label: i18n.t("sister"),
    value: DependentRelationship.Sister,
  },
  {
    label: i18n.t("children"),
    value: DependentRelationship.Child,
  },
  {
    label: i18n.t("father"),
    value: DependentRelationship.Father,
  },
  {
    label: i18n.t("mother"),
    value: DependentRelationship.Mother,
  },
  {
    label: i18n.t("adoptiveChild"),
    value: DependentRelationship.AdoptiveChild,
  },
  {
    label: i18n.t("fatherInLaw"),
    value: DependentRelationship.FatherInLaw,
  },
  {
    label: i18n.t("motherInLaw"),
    value: DependentRelationship.MotherInLaw,
  },
  {
    label: i18n.t("adoptiveFather"),
    value: DependentRelationship.AdoptiveFather,
  },
  {
    label: i18n.t("adoptiveMother"),
    value: DependentRelationship.AdoptiveMother,
  },
  {
    label: i18n.t("stepFather"),
    value: DependentRelationship.StepFather,
  },
  {
    label: i18n.t("stepMother"),
    value: DependentRelationship.StepMother,
  },
  {
    label: i18n.t("wife"),
    value: DependentRelationship.Wife,
  },
  {
    label: i18n.t("husband"),
    value: DependentRelationship.Husband,
  },
  {
    label: i18n.t("niece"),
    value: DependentRelationship.Niece,
  },
  {
    label: i18n.t("nephew"),
    value: DependentRelationship.Nephew,
  },
  {
    label: i18n.t("grandpa"),
    value: DependentRelationship.Grandpa,
  },
  {
    label: i18n.t("grandma"),
    value: DependentRelationship.Grandma,
  },
  {
    label: i18n.t("aunt"),
    value: DependentRelationship.Aunt,
  },
  {
    label: i18n.t("uncle"),
    value: DependentRelationship.Uncle,
  },
  {
    label: i18n.t("others"),
    value: DependentRelationship.Others,
  },
];

export const DependentGenderOptions = [
  {
    label: i18n.t("male"),
    value: DependentGender.Male,
  },
  {
    label: i18n.t("female"),
    value: DependentGender.Female,
  },
  {
    label: i18n.t("other"),
    value: DependentGender.Other,
  },
];

export const DependentRelationshipMap = getMapObjectFromArray(
  DependentRelationshipOptions
);
